import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ViToastService } from '@vi-iot/ui';

import { UIService } from '@services';

import { DocumentsStore } from '../../documents/documents.store';

import { LanguageActions } from './language.actions';
import { SUPPORTED_LANGUAGE } from './language.model';

@Injectable()
export class LanguageEffects {
  getLanguage$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(LanguageActions.getLanguage),
      switchMap(() => {
        try {
          const splitedLanguageCode: string[] = localStorage.getItem('lang').split('-');
          const languageCode = splitedLanguageCode[0].toUpperCase();

          return of(
            LanguageActions.getLanguageSuccess({
              languageCode: SUPPORTED_LANGUAGE[languageCode],
            })
          );
        } catch (err) {
          return of(LanguageActions.getLanguageError());
        }
      })
    );
  });

  setLanguage$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(LanguageActions.setLanguage),
      switchMap((action) => {
        this.uiService.blockUI();
        try {
          localStorage.setItem('lang', action.languageCode);
          this.translate.use(action.languageCode);
          this.uiService.unblockUI();
          this.toast.info({
            message: this.translate.instant('+SETTINGS.LANGUAGE.CHANGE_SUCCESS'),
          });
          this.documentsStore.getDocuments();

          return of(LanguageActions.setLanguageSuccess());
        } catch (err) {
          this.uiService.unblockUI();
          this.toast.error({
            message: this.translate.instant('+SETTINGS.LANGUAGE.CHANGE_FAILURE'),
          });

          return of(LanguageActions.setLanguageError());
        }
      })
    );
  });

  constructor(
    private actions$: Actions,
    private uiService: UIService,
    private toast: ViToastService,
    private translate: TranslateService,
    private documentsStore: DocumentsStore
  ) {}
}
